import request, { download } from '@/utils/request'


export function getList (query) {
  return request({
    url: `/system/product/list`,
    method: 'post',
    data: query,
    headers: { repeatSubmit: false },
    params: {
      pageSize: query.pageSize,
      pageNum: query.pageNum
    }
  })
}
export function geProducttList (query, params) {
  return request({
    url: `/system/product/list`,
    method: 'post',
    data: query,
    headers: { repeatSubmit: false },
    params
  })
}
//修改
export function editProduct (query) {
  return request({
    url: `/system/product`,
    method: 'put',
    data: query
  })
}

//新增
export function addProduct (query) {
  return request({
    url: `/system/product`,
    method: 'post',
    data: query
  })
}

//详情
export function getDetail (id) {
  return request({
    url: `/system/product/${id}`,
    method: 'get',
  })
}
//导出
export function productExport (query) {
  return download(`/system/product/export`, { ...query }, `产品管理_${new Date().getTime()}.xlsx`)
}
//修改启用状态
export function changeStatus (params) {
  return request({
    url: `/system/product/changeStatus`,
    method: 'get',
    params: params
  })
}

//查询产品明细
export function productDetail (id) {
  return request({
    url: `/system/product/detail/${id}`,
    method: 'get'
  })
}

//新增产品明细
export function addProductDetail (data) {
  return request({
    url: `/system/product/detail/${data.id}`,
    method: 'post',
    data
  })
}


// 复训协议查询
export function findReTrainAgree (params) {
  return request({
    url: `/system/crm/planningSearch/searchClass`,
    method: 'post',
    data: params
  })
}

//同步协议模板
export function synchronizeTemplates () {
  return request({
    url: `/system/product/synchronizeTemplates`,
    method: 'post',
  })
}

//新增产品别名
export function addProductAlias (data) {
  return request({
    url: `/system/product/addProductAlias`,
    method: 'post',
    data
  })
}

//删除产品别名
export function deleteProductAlias (params) {
  return request({
    url: `/system/product/deleteProductAlias`,
    method: 'get',
    params
  })
}

//通过产品id获取产品别名
export function getAliasProduct (params) {
  return request({
    url: `/system/product/getAliasProduct`,
    method: 'get',
    params
  })
}


//获取关联关联交付方案数据
export function getConsignScheme (params) {
  return request({
    url: '/system/product/checkProductDetailConsignSchemeBySubjectId',
    method: 'post',
    headers: { repeatSubmit: false },
    params
  })
}


//复制产品
export function copyProduct (data) {
  return request({
    url: '/system/product/copyProduct',
    method: 'post',
    headers: { repeatSubmit: false },
    data
  })
}


//AI生成课程概述
export function getAiCourseOverview (data) {
  return request({
    url: `/system/product/getAiCourseOverview/${data.id}`,
    method: 'post',
    data
  })
}

//获取课程概述AI提示词
export function getCoursePrompt (params) {
  return request({
    url: '/system/ai/prompts/get/type',
    method: 'get',
    params
  })
}

//保存课程概述AI提示词
export function saveCoursePrompt (data) {
  return request({
    url: '/system/ai/prompts/save',
    method: 'post',
    data
  })
}